export default __webpack_public_path__ + "static/media/success-new.88bcf057.svg";